import { SamplesListPage } from '~/components/Samples/SamplesListPage'

export default function SamplesRoutePage() {
  return <SamplesListPage />
}